import { useRef } from 'react';
import getRelatedTarget$1 from '../getRelatedTarget.js';

/**
 * Handles focus events for the target and its descendants.
 */

function useFocusWithin(props) {
  var state = useRef({
    isFocusWithin: false
  }).current;

  if (props.isDisabled) {
    return {
      focusWithinProps: {}
    };
  }

  var onFocus = function onFocus(e) {
    if (!state.isFocusWithin) {
      if (props.onFocusWithin) {
        props.onFocusWithin(e);
      }

      if (props.onFocusWithinChange) {
        props.onFocusWithinChange(true);
      }

      state.isFocusWithin = true;
    }
  };

  var onBlur = function onBlur(e) {
    if (state.isFocusWithin && !e.currentTarget.contains(getRelatedTarget$1(e))) {
      if (props.onBlurWithin) {
        props.onBlurWithin(e);
      }

      if (props.onFocusWithinChange) {
        props.onFocusWithinChange(false);
      }

      state.isFocusWithin = false;
    }
  };

  return {
    focusWithinProps: {
      onFocus: onFocus,
      onBlur: onBlur
    }
  };
}

export default useFocusWithin;
